import { render, staticRenderFns } from "./event_add.vue?vue&type=template&id=bf7a20a6&"
import script from "./event_add.vue?vue&type=script&lang=js&"
export * from "./event_add.vue?vue&type=script&lang=js&"
import style0 from "./event_add.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports